import {
	PCFSoftShadowMap
} from "../../../src/js/three.module.js";

export const RENDERER_DEFAULTS_BASE = {
	antialias       : true, 				// three.js default false
	powerPreference : "high-performance",	// three.js default "default"
	precision       : "mediump",			// three.js default "highp"
	shadowMap: {
		enabled: true,
		autoUpdate: false,					// Päivitys tehtävä muutosten tapahduttua!
		type: PCFSoftShadowMap				// three.js default PCFShadowMap
	},
	stencil: false,							// three.js default true
	preserveDrawingBuffer: false,
	depth: true,
	alpha: false,
};

export const RENDERER_DEFAULTS_PERFORMANCE_LEVEL_LOW = {
	antialias: false,
	precision: "lowp",
	shadowMap: {
		enabled: false
	}
};

export const RENDERER_DEFAULTS_PERFORMANCE_LEVEL_HIGH = {
	antialias: true
};

export const RENDERER_DEFAULTS_DEBUG = {
	antialias: false
}

export class GameSceneRenderer {

    static buildParameters( parameters_overwrite = null, performance_level = null )  {

        let parameters = angular.merge({ }, RENDERER_DEFAULTS_BASE );
        
        if (performance_level) {
            switch (performance_level) {
                case "LOW":
                    angular.merge( parameters, RENDERER_DEFAULTS_PERFORMANCE_LEVEL_LOW );
                    break;

                case "HIGH":
                    angular.merge( parameters, RENDERER_DEFAULTS_PERFORMANCE_LEVEL_HIGH );
                    break;
            }
        }

        if (window.DEBUG) {
            angular.merge( parameters, RENDERER_DEFAULTS_DEBUG );
        }

        if (parameters_overwrite) angular.extend( parameters, parameters_overwrite );;

        return parameters;
    }

	static solvePerformanceLevel() {

		try {
			return location.search.split(/[\?&]/).concat( location.hash.split(/[\?&]/) ).filter( param => param.indexOf("performance=") != -1 )[0].substring(12).toUpperCase();
		} catch (e) {}

		return null;
	}
}